<template>
  <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item>
        <el-select style="width: 100%;" v-model="companyId" clearable placeholder="请选择所属公司">
          <el-option
            v-for="item in companys"
            :key="item.Id"
            :value="item.Id"
            :label="item.CompanyName"
          >
            <span style="float: left">{{ item.CompanyName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="driverName" style="width: 150px;" placeholder="请输入司机姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="employmentStatus" clearable placeholder="请选择从业状态">
          <el-option
            v-for="item in employmentStatusList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.IsHide" @click="callFunc(item)">{{item.name}}</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
import { getCompanyListPage } from "../../api/api";

export default {
  name: "DriverToolbar",
  data() {
    return {
      companys: [], //企业列表
      companyId:"", //企业ID
      driverName:"", //司机姓名
      employmentStatus:"", //从业状态
      employmentStatusList: [
        { name: "在职", value: "在职" },
        { name: "离职", value: "离职" }
      ]
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      item.companyId = this.companyId;
      item.driverName = this.driverName;
      item.employmentStatus = this.employmentStatus;
      this.$emit("callFunction", item); //将值传给父组件
    }
  },
  mounted() {
    let para = {
      companyName: "",
      operatingStatus: "true",
      enabled: "true",
      page: 1,
      pageSize: 100
    };
    getCompanyListPage(para).then(res => {
      this.companys = res.data.response.data;
    });
  }
};
</script>